import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { RootLayout } from '@/layouts/RootLayout';
import { Overview } from '@/routes/Overview';
import { Sites } from '@/routes/Sites';
import { Projects } from '@/routes/Projects';
import { Actions } from '@/routes/Actions';
import { Pipeline } from '@/routes/Pipeline';
import { Campaigns } from '@/routes/Campaigns';
import { Maintenance } from '@/routes/Maintenance';
import { Network } from '@/routes/Network';

const rootRoute = createRootRoute({ component: RootLayout });

const overviewRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: Overview });
const sitesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/sites', component: Sites });
const campaignsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/campaigns', component: Campaigns });
const projectsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/projects', component: Projects });
const actionsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/actions', component: Actions });
const pipelineRoute = createRoute({ getParentRoute: () => rootRoute, path: '/pipeline', component: Pipeline });
const maintenanceRoute = createRoute({ getParentRoute: () => rootRoute, path: '/maintenance', component: Maintenance });
const networkRoute = createRoute({ getParentRoute: () => rootRoute, path: '/network', component: Network });

const routeTree = rootRoute.addChildren([overviewRoute, sitesRoute, campaignsRoute, projectsRoute, actionsRoute, pipelineRoute, maintenanceRoute, networkRoute]);

// import.meta.env.BASE_URL est calculé par Vite à partir de `base` (vite.config.ts)
// '/v2/' en dev local, '/' en prod (sous-domaine dédié dashboard.akaz.fr)
const basepath = (import.meta.env.BASE_URL || '/').replace(/\/+$/, '') || '/';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  basepath,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
